import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import swal from 'sweetalert2';

import { AuthService } from '../../shared/services/auth.service';
import { ContractService } from '../../shared/services/contract.service';

import { LoginModel } from '../../shared/models/login.model';
import { ConsultaLista } from '../../shared/models/consulta-lista.model';
import { Lista } from '../../shared/models/lista.model';
import { CacheService } from '../../shared/models/cache-service.model';
import { SessionService } from '../../shared/services/session.service';
import { UserService } from '../../shared/services/user.service';
import { TipoAcceso } from '../../shared/enumeration/tipo-acceso.enum';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  showSpinner: boolean;
  urlParam: string;
  login: LoginModel;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _authService: AuthService,
    private _sessionService: SessionService,
    private _contractService: ContractService,
    private _userService: UserService,
  ) {
    this.login = new LoginModel("", "");

    if (window.location.search !== '') {
      let _patron = '?entry=';
      if (window.location.search.substring(0, _patron.length) === _patron) {
        let _parameter = this.getParams(window.location.href);
        let _token = _parameter.entry;
        swal({
          html: `<img src="./assets/images/loading.gif" width="45"/><br/><br/><p style="font-size: 14px">Iniciando Sesión...</p>`,
          showConfirmButton: false,
          allowOutsideClick: false,
          buttonsStyling: false,
          focusConfirm: false
        });
        this.onSubmit(_token, TipoAcceso.AccesoExterno);
      }

      let _patronResult = '?result=';
      if (window.location.search.substring(0, _patronResult.length) === _patronResult) {
        let _parameter = this.getParams(window.location.href);
        let _result = _parameter.result;

        swal({
          title: 'Autenticación',
          html: '<p style="font-size:14px">' + (_result === 'unauthorized' ? 'Usuario no registrado, o sin contratos activos' : 'Ocurrio un inconveniente. Por favor intente nuevamente') + '</p>',
          type: (_result === 'unauthorized' ? 'warning' : 'error'),
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false
        });

      }

      let _patronManagement = '?entry_mp=';
      if (window.location.search.substring(0, _patronManagement.length) === _patronManagement) {
        let _parameter = this.getParams(window.location.href);
        let _token = _parameter.entry_mp;
        let _user = _parameter.user;
        this.login.user = _user;
        swal({
          html: `<img src="./assets/images/loading.gif" width="45"/><br/><br/><p style="font-size: 14px">Iniciando Sesión...</p>`,
          showConfirmButton: false,
          allowOutsideClick: false,
          buttonsStyling: false,
          focusConfirm: false
        });
        this.onSubmit(_token, TipoAcceso.AccesoManagement);

      }
    }
  }

  getParams(url): any {
    var regex = /[?&]([^=#]+)=([^&#]*)/g,
      params = {},
      match;
    while (match = regex.exec(url)) {
      params[match[1]] = match[2];
    }
    return params;
  }

  ngOnInit() {
    this.showSpinner = false;
  }

  onSubmit(token: string, tipoAcceso: number) {

    this.showSpinner = true;

    this._authService.logIn(this.login, token, tipoAcceso).subscribe(
      res => {
        let _patron = '?id=1';
        let idLogin = "0";
        if (window.location.search.substring(0, _patron.length) === _patron) {
          idLogin = ("1");
        }
        this._sessionService.setIdLogin(idLogin);
        //console.log(res);
        this._sessionService.setCurrentUser(res);
        this._sessionService.setCache(new CacheService());

        this._contractService.postContracts({ dato: res.user }).subscribe(
          res => {
            //console.log(res.length);             
            if (res.length == 1) {

              this._sessionService.setSelectContract(res[0].id);
              this._sessionService.setSelectDocumentTypeContracted(res[0].documentType);

              let _user = this._sessionService.getCurrentUser();

              //Saber si es contratante
              this._userService.isUpdateData({ user: _user.user, contractNumber: _user.contractNumber }).subscribe(
                res => {

                  let __user = this._sessionService.getCurrentUser();
                  __user.actualizacionMenu = res;
                  this._sessionService.setCurrentUser(__user);

                  this._contractService.getDataContract(__user.contractNumber).subscribe(
                    async res => {
                      this.showSpinner = false;
                      swal.close();
                      this._sessionService.setDataContract(res, false);
                      /*----------------------------------------|
                      |Validacion para web view,                |
                      |pasa directamente a la opcion de pagos   |
                      |de lo contrario entra a home normalmente
                      |----------------------------------------*/
                      if (idLogin == "1") {
                        this._router.navigate(['/office/account_status/status'])
                      }
                      else if (tipoAcceso == TipoAcceso.AccesoManagement) {
                        this._router.navigate(['/office/home']);
                      }
                      else {
                        let path = sessionStorage.getItem('urlsesion')
                       
                        if (!path) {
                          path = '/office/home';
                        }

                        this._router.navigate([path]);
                      }
                    },
                    err => {
                      this.showSpinner = false;
                      console.log(err);
                      swal({
                        title: 'Autenticación',
                        html: '<p style="font-size:14px">Ocurrio un inconveniente. Por favor intente nuevamente</p>',
                        type: 'warning',
                        confirmButtonClass: 'btn btn-primary',
                        buttonsStyling: false,
                        focusConfirm: false
                      });
                    }
                  );
                },
                err => {
                  this.showSpinner = false;
                  //console.log(err);
                  swal({
                    title: 'Autenticación',
                    html: '<p style="font-size:14px">Ocurrio un inconveniente. Por favor intente nuevamente</p>',
                    type: 'warning',
                    confirmButtonClass: 'btn btn-primary',
                    buttonsStyling: false,
                    focusConfirm: false
                  });
                }
              );

            } else {
              this.showSpinner = false;
              swal.close();
              this._sessionService.setContracts(res);
              this._router.navigate(['/auth/contract']);

            }

          },
          err => {
            this.showSpinner = false;
            swal({
              title: 'Autenticación',
              html: '<p style="font-size:14px">Ocurrio un inconveniente. Por favor intente nuevamente</p>',
              type: 'warning',
              confirmButtonClass: 'btn btn-primary',
              buttonsStyling: false,
              focusConfirm: false
            });
          }
        );

      },
      err => {

        this.showSpinner = false;

        if (err.status === 401 || err.status === 404 || err.status === 500) {
          swal({
            title: 'Autenticación',
            html: '<p style="font-size:14px">' + err.error.message + '</p>',
            type: err.error.type,
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });

        } else {
          swal({
            title: 'Autenticación',
            html: '<p style="font-size:14px">Existen problemas con la conexión al servidor</p>',
            type: 'error',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });
        }
      }
    );

  }

  forgotPassword() {
    this._router.navigate(['/auth/forgot_password']);
  }

  register() {
    this._router.navigate(['/auth/register']);
  }

}



// WEBPACK FOOTER //
// /app/src/app/auth/login/login.component.ts